// @flow
import * as React from 'react';

export type CountryDisplayName = {|
  code: string,
  name: string | null,
  name_with_article: string | null,
|};

type CountryNameProps = {|
  code: string,
  include_article?: boolean,
  countries: Array<CountryDisplayName>,
|};

export const CountryName = ({
  code,
  include_article,
  countries,
}: CountryNameProps) => {
  const country = countries?.find((c) => c.code === code);
  const countryName =
    include_article && country?.name_with_article
      ? country?.name_with_article
      : country?.name;

  if (!countryName) {
    return null;
  }

  return <span>{countryName}</span>;
};
